import JobSeekersSideBarList from "./JobSeekersSideBarList";

function JobSeekersMatchSidebar() {

    return (
      <div className="JobSeekersMatchSidebar">
       <JobSeekersSideBarList />
      </div>
    );
  }
  
  export default JobSeekersMatchSidebar;